import { RouteType } from "types/RouteType";
import estimatingDashboardRoute from "./Dashboard/EstimatingDashboard.Route";
import manholeRoute from "./Manhole/Manhole.Route";
import {
  IntraSyncDesignerRoute as intraSyncDesignerRoute,
  IntraSyncDesignerPreviewRoute as intraSyncDesignerPreviewRoute,
} from "@intrasync/stack-designer";
import jobListRoute from "./JobManagement/JobList.Route";
import jobDetailRoute from "./JobManagement/JobDetail.Route";

const estimatingRoutesList: RouteType[] = [
  estimatingDashboardRoute,
  manholeRoute,
  intraSyncDesignerRoute,
  intraSyncDesignerPreviewRoute,
  jobListRoute,
  jobDetailRoute,
];

export default estimatingRoutesList;
